// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import { sync } from 'vuex-router-sync'

sync(store, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
// // 监听刷新
// window.addEventListener('resize', function () {
//   const body = document.querySelector('body');
//   const backgroundImage = body.style.backgroundImage;
//   if (!backgroundImage || backgroundImage === 'none') {
//     location.reload();
//   }
// });

// // 检查页面是否是通过后退按钮加载的
// window.addEventListener('load', function () {
//   // 获取当前页面的历史记录状态值
//   let currentState = history.state;
//   // 监听 popstate 事件，当浏览器后退时触发
//   window.addEventListener('popstate', function () {
//     // 再次获取历史记录状态值，如果和初始状态值不同，说明发生了后退操作
//     if (history.state !== currentState) {
//       location.reload();
//     }
//   });
// });


//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 123
// module chunks = 0